package app.nestbridge.feature.invitations.usecase

import app.nestbridge.feature.invitations.service.InvitationService
import me.tatarka.inject.annotations.Inject

@Inject
class AcceptInvitationUseCase(
    private val invitationService: InvitationService,
) {
    suspend operator fun invoke(invitationId: String): Result<Unit> =
        invitationService.accept(invitationId)
}
